import qs from "qs";
import { useHistory } from "react-router-dom";

export const useQueryParams = () => {
  const { location } = useHistory();

  return qs.parse(location.search, { ignoreQueryPrefix: true });
};
